import { ImageList } from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import { orderBy } from "lodash";
import { useContext } from "react";
import Scrollbar from "src/components/Scrollbar";
import useResponsive from "src/hooks/useResponsive";
import { ConnectedEntity } from "src/types/apps";

import ThemeContext from "../../../../context";
import Context from "../../context";
import EntityItem from "../../EntityItem/EntityItem";
import EmptyMessage from "./EmptyMessage";

// ----------------------------------------------------------------------

export const EntityItemList = () => {
	const { state } = useContext(ThemeContext);
	const entityState = useContext(Context);

	const { data } = useQuery<ConnectedEntity[]>({
		queryKey: ["link", "entities", state.authToken],
		initialData: []
	});

	const entities = data.filter((item) =>
		item.name.toLowerCase().includes(entityState.state.filterName.toLowerCase())
	);

	const isMobile = useResponsive("down", "sm");
	const isDesktop = useResponsive("up", "md");

	if (entities.length === 0) return <EmptyMessage />;

	return (
		<Scrollbar sx={{ height: isMobile ? "auto" : 426 }}>
			<ImageList
				cols={isDesktop ? 4 : isMobile ? 1 : 2}
				sx={{ mt: 2, pb: 2 }}
				data-testId='imageListId'
			>
				{orderBy(entities, "name").map((item) => (
					<EntityItem item={item} key={item.id} />
				))}
			</ImageList>
		</Scrollbar>
	);
};

export default EntityItemList;
